const WdioSelector = (parentSelector, selector) => {
  if (typeof selector === "object") {
    return `>>> ${parentSelector} ${selector.selector}`;
  }
  return `>>> ${parentSelector} ${selector}`;
};
const WdioWrapper = (parentSelector, children) => {
  return Object.entries(children).reduce((acc, [key, selector]) => {
    acc[key] = WdioSelector(parentSelector, selector);
    return acc;
  }, {});
};
export {
  WdioSelector,
  WdioWrapper
};
